import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie';
import { ApiModule } from '../api/api.module';
import { GroupService } from './group.service';
import {UserDirectoryService} from './user-directory.service';
import {ViewService} from './view.service';
import {QuestionnaireService} from './questionnaire.service';
import {ComplianceItemService} from './compliance-item.service';
import {FileService} from './file.service';
import {VerifyService} from './verify.service';
import {RegistrationService} from './registration.service';
import {NoteService} from './note.service';
import {ComplyMessageService} from './comply-message.service';
import {TagService} from './tag.service';
import { Act48Service } from './a48.service';
import { Act48ReportService } from './a48-report.service';
import { ResizeableService } from './resizeable.service';
import { RequestItemService } from './request-item.service';
import { RequestItemActionService } from './request-item-action.service';
import {RequestVerifyService} from './request-verify.service';
import {UserRequestService} from './user-request.service';
import { RequestHelpersService } from './request-helpers/request-helpers.service';
import { ComplianceItemHelpersService } from './compliance-item-helpers/compliance-item-helpers.service';
import { MetricService } from './metric.service';
import { ComplianceItemActionService } from './compliance-item-action.service';
import { A48HelpersService } from './a48-helpers/a48-helpers.service';
import { PortalHelpersService } from './portal-helpers/portal-helpers.service';
import { BaseItemHelpersService } from './base-item-helpers/base-item-helpers.service';
import { UserCycleService } from './user-cycle/user-cycle.service';
import { Act48ReportHelpersService } from './a48-report-helpers/a48-report-helpers.service';
import { RosterPreferenceService } from './roster-preference/roster-preference.service';
import { OnboardingService } from './onboarding/onboarding.service';

@NgModule({
    imports: [
        CommonModule,
        ApiModule
    ],
    providers: [
        CookieService,
        OnboardingService,
        GroupService,
        UserDirectoryService,
        ViewService,
        QuestionnaireService,
        ComplianceItemService,
        ComplianceItemActionService,
        ComplianceItemHelpersService,
        FileService,
        VerifyService,
        RegistrationService,
        NoteService,
        ComplyMessageService,
        TagService,
        Act48Service,
        Act48ReportService,
        Act48ReportHelpersService,
        ResizeableService,
        RequestHelpersService,
        RequestItemService,
        RequestItemActionService,
        RequestVerifyService,
        UserRequestService,
        MetricService,
        A48HelpersService,
        PortalHelpersService,
        BaseItemHelpersService,
        UserCycleService,
        RosterPreferenceService
    ]
})
export class ServiceModule { }